import { useMutation } from "@tanstack/react-query";
import { ClusterHealthAlerts } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
const createHealthAlert = (request) => ClusterHealthAlerts.create(request);
const useCreateHealthAlert = () => {
  const mutation = useMutation({
    mutationFn: createHealthAlert,
    onError: (errorThrown) => {
      var _a, _b;
      if (errorThrown.status !== 400 || !((_b = (_a = errorThrown.additional) == null ? void 0 : _a.body) == null ? void 0 : _b.failed)) {
        UserNotification.error(
          `Creating health alert failed with status: ${errorThrown}`,
          "Could not create health alert"
        );
      }
    },
    onSuccess: (eventDefinition) => {
      UserNotification.success(
        "Health alert created successfully",
        `Health alert "${eventDefinition.title}" was created successfully.`
      );
    }
  });
  return { createHealthAlert: mutation.mutateAsync, isCreating: mutation.isPending };
};
export default useCreateHealthAlert;
